/**
 * 営業設定 > カテゴリー管理タブ (v3.2.21+)。
 *
 * v3.2.21 で商談ボードから営業設定に移動。既存 CategoryManagementTab を埋め込み。
 */
import { CategoryManagementTab } from '@/pages/deals/categories/CategoryManagementTab';

export function CategoriesTab() {
  return <CategoryManagementTab />;
}
